import React, { useState, useRef, useEffect } from "react";
import FreeToolsLayout from "./FreeToolsLayout";
import sparkleWhite from "~/images/sparkle-white.svg";
import sparklePurple from "~/images/sparkle-purple.svg";
import { generateRobotTxt } from "../../api/freeToolsApis";
import ResultDescription from "./ResultDescription";
import GenerateResults from "../shared/GenerateResults";
const RobotTxtGenerator = () => {
  const [userAgent, setUserAgent] = useState("*");
  const [disallowPaths, setDisallowPaths] = useState("");
  const [allowPaths, setAllowPaths] = useState("");
  const [sitemapUrl, setSitemapUrl] = useState("");
  const [generated, setGenerated] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const resultRef = useRef(null);

  const handleGenerate = async () => {
    setError("");
    setGenerated("");

    if (!userAgent.trim()) {
      setError("Please enter a user agent");
      return;
    }

    setLoading(true);

    try {
      const response = await generateRobotTxt({ user_agent: userAgent, disallow_paths: disallowPaths, allow_paths: allowPaths, sitemap_url: sitemapUrl });
      if (response.status === 200) {
        setGenerated(response.data.robots_txt);
      } else {
        throw new Error(response.data.error || "Failed to generate robots.txt");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getButtonText = () => {
    if (loading) return "Generating...";
    if (generated) return "Generate Again";
    return "Generate";
  };

  useEffect(() => {
    if (generated && resultRef.current) {
      resultRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [generated]);
  return (
    <FreeToolsLayout mainHeading="Robots.txt Generator" subHeading="Create a proper robots.txt file for your website to control search engine crawling">
      <div className="bg-white/70 rounded-[20px] py-8 px-[26px] shadow-md shadow-[#6248fe1f] relative min-h-[200px]">
        <div className="mb-4">
          <label className="text-[#3f3f3f] text-base font-bold mb-1">User Agent</label>
          <p className="text-[#696969] text-sm mb-2">Leave as * for all robots or specify a user agent (e.g., Googlebot)</p>
          <input
            type="text"
            class="w-full bg-transparent rounded-lg border-[#e9e4ff] outline-none focus:border-[#e9e4ff] text-black placeholder-[#707070] focus:ring-0 text-sm"
            placeholder="* (all robots)"
            value={userAgent}
            onChange={(e) => setUserAgent(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="text-[#3f3f3f] text-base font-bold mb-1">Disallow Paths</label>
          <p className="text-[#696969] text-sm mb-2">Enter one path per line (e.g., /admin/)</p>
          <div class="mt-2">
            <textarea
              placeholder="/admin/&#10;/private/&#10;/temp/"
              value={disallowPaths}
              onChange={(e) => setDisallowPaths(e.target.value)}
              id="inputText"
              className="w-full pr-16 bg-transparent rounded-lg border-[#e9e4ff] outline-none focus:border-[#e9e4ff] resize-none text-sm min-h-[120px] text-black placeholder-[#707070] focus:ring-0"
            ></textarea>
          </div>
        </div>

        <div className="mb-4">
          <label className="text-[#3f3f3f] text-base font-bold mb-1">Allow Paths</label>
          <p className="text-[#696969] text-sm mb-2">Enter one path per line (e.g., /blog/)</p>
          <div class="mt-2">
            <textarea
              placeholder="/public/&#10;/blog/&#10;/products/"
              value={allowPaths}
              onChange={(e) => setAllowPaths(e.target.value)}
              id="inputText"
              className="w-full pr-16 bg-transparent rounded-lg border-[#e9e4ff] outline-none focus:border-[#e9e4ff] resize-none text-sm min-h-[120px] text-black placeholder-[#707070] focus:ring-0"
            ></textarea>
          </div>
        </div>
        <div className="mb-4">
          <label className="text-[#3f3f3f] text-base font-bold mb-1">Sitemap URL</label>
          <p className="text-[#696969] text-sm mb-2">Optional: Add your sitemap URL</p>
          <input
            type="text"
            class="w-full bg-transparent rounded-lg border-[#e9e4ff] outline-none focus:border-[#e9e4ff] text-black placeholder-[#707070] focus:ring-0 text-sm"
            placeholder="https://example.com/sitemap.xml"
            value={sitemapUrl}
            onChange={(e) => setSitemapUrl(e.target.value)}
          />
        </div>
        <GenerateResults handleGenerate={handleGenerate} loading={loading} text={getButtonText()} />
      </div>
      {error && <div className="text-red-600 text-sm px-2">{error}</div>}
      {generated && (
        <div ref={resultRef}>
          <div className="flex items-center justify-center mb-4">
            <img src={sparklePurple} />
          </div>
          <ResultDescription description={generated} />
        </div>
      )}
    </FreeToolsLayout>
  );
};

export default RobotTxtGenerator;
